t = require('views/internal/teacup-with-helpers')('header_warning_account_transfer_required_missed')

module.exports = t.renderable ->
  t.p '.u-bottom', ->
    t.p ->
      t.format 'missed-transfer-date'
      t.text " "
      t.a '.quiet', { href: "/transfer-account/missed-date" }, ->
        t.format 'convert-now'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/header_warning_account_transfer_required_missed.coffee